export default __webpack_public_path__ + "static/media/hht2_timeline.cf98bb4d.png";